<div class="clear-input">
  <input
    type="text"
    class="full-width"
    placeholder="{{ placeholder }}"
    [matTooltip]="tooltip"
    matTooltipShowDelay="500"
    (keydown.enter)="onAddChip(chipInput.value)"
    (keydown.escape)="onEscapeKey()"
    #chipInput
    />
    <i
      class="return-icon"
      [ngClass]="{ green: addingChip }"
      (click)="onAddChip(chipInput.value)"
      [matTooltip]="'Hit `Enter` to add'"
      matTooltipShowDelay="500"
    ></i>
    <mat-icon
      fontIcon="close"
      class="clear-icon"
      (click)="clearInput(chipInput, true)"
      [matTooltip]="chipInput.value ? 'Clear' : ''"
      matTooltipShowDelay="500"
    ></mat-icon>
  </div>
  @if (chips.length > 0) {
    <div class="chips-container" @appearHeight>
      @for (chip of chips; track $index) {
        <button
          class="chip"
          [matTooltip]="chip ? '' : 'Empty value'"
          matTooltipShowDelay="500"
          tabindex="-1"
          @appearWidth
          >
          {{ chip }}
          <mat-icon
            fontIcon="close"
            class="remove-chip"
            [matTooltip]="'Remove ' + chip"
            matTooltipShowDelay="500"
            (click)="onRemoveChip(chip)"
            (keydown.enter)="onRemoveChip(chip)"
            (keydown.space)="onRemoveChip(chip)"
            tabindex="0"
          ></mat-icon>
        </button>
      }
    </div>
  }
